import React from "react";
import { useSelector } from "react-redux";
import Widget from "../../../../shared/components/features/widget/Widget";
import NavigateLink from "../../../../shared/components/features/navigateLink/navigateLink";
import faceToFaceExamIcon from "../../../../assests/finalProjects/faceToFaceExamIcon.png";
import classes from "./FinalProjectFaceToFaceExamWidget.module.css";

const FinalProjectFaceToFaceExamWidget = () => {

    const { texts } = useSelector(state => state.translate);
    const general = useSelector(state => state.uiData?.general);

    return (
        <Widget
            color="#F2F4F6"
            className={classes.FaceToFaceExamWidget}
            title={texts.faceToFaceExamWidget}
            contentScrollable={false}
        >
            <NavigateLink link={general?.FinalProject?.faceToFaceExamLink}>
                <div className={classes.FaceToFaceExamContent}>
                    <div className={classes.FaceToFaceExamHeader}>
                        <img src={faceToFaceExamIcon} alt="" className={classes.Icon} />
                        <span className={classes.FaceToFaceExamText}>{texts.faceToFaceExamTitle}</span>
                    </div>
                    <div className={classes.FaceToFaceExamDescription}>
                        <p className={classes.DescriptionText}>{texts.faceToFaceExamDescription}</p>
                        <p className={classes.DeadlineText}>{texts.faceToFaceExamDueDate}</p>
                    </div>
                </div>
            </NavigateLink>
        </Widget>
    );
};

export default FinalProjectFaceToFaceExamWidget;
